import { Labels } from '../../shared-components/global/labels.js';

Labels.set('validation', 'input', 'Введите, пожалуйста, верные данные.');
Labels.set('validation', 'date', 'Введите, пожалуйста, верные данные.');
Labels.set('validation', 'time', 'Укажите, пожалуйста, время.');
Labels.set('validation', 'range', 'Данные указаны неверно.');
Labels.set('validation', 'month', 'Укажите, пожалуйста, месяц.');
Labels.set(
    'validation',
    'datetime-local',
    'Укажите, пожалуйста, дату и время.'
);
Labels.set(
    'validation',
    'custom',
    'Ошибка. Проверьте, пожалуйста, введённые данные.'
);
Labels.set('validation', 'pattern', 'Выберите, пожалуйста, формат.');
Labels.set(
    'validation',
    'rangeOverflow',
    'Значение должно быть равно или меньше %s.'
);
Labels.set(
    'validation',
    'rangeUnderflow',
    'Значение должно быть равно или больше %s.'
);
Labels.set(
    'validation',
    'step',
    'Шаг должен составлять %s, ближайшие значения – %s и %s'
);
Labels.set(
    'validation',
    'long',
    'Слишком большое значение, максимальное количество символов – %s  '
);
Labels.set(
    'validation',
    'short',
    'Слишком маленькое значение, минимальное количество символов – %s  '
);
Labels.set('validation', 'type', 'Введите, пожалуйста, верные данные.');
Labels.set('validation', 'email', 'Введите, пожалуйста, адрес э-почты.');
Labels.set('validation', 'url', 'Введите, пожалуйста, URL-адрес.');
Labels.set('validation', 'value', 'Заполните, пожалуйста, это поле.');

// User defined rule validations
Labels.set('validation', 'matches', 'Данные полей не совпадают.');
Labels.set(
    'validation',
    'checkboxes',
    'Выберите, пожалуйста, хотя бы %s вариант(а/ов).'
);
Labels.set('validation', 'remote', 'Ошибка сервера');
Labels.set('validation', 'maxfilesize', 'Размер файла(-ов) больше чем %s Kb.');
Labels.set(
    'validation',
    'requiredMultiple',
    'Заполните, пожалуйста, хотя бы %s вариант(а/ов).'
);
